import React from 'react'
import { DateRangePicker } from '../../_library/DateRangePicker'
import LoadingBar from '../../_library/LoadingBar'
import SortableTable from '../../_library/SortableTable/index'
import EmptyBar from '../../_library/EmptyBar'
import { getTableColumns } from '../../utils/sortableTableUtils'
import { formatDay, formatDateTime } from '../../../_common/core/validation/normalizers'
import { SaveTemplate, SelectFilterTemplate } from '../../_library/FilterTemplate'
import CardHeader from '../../_library/CardHeader'
import TrafficViewChart from './components/TrafficViewChart'
import moment from 'moment'
import { showAxiosError } from '../../utils/messenger'
import ProgressCircle from '../../_library/ProgressCircle'

export default class TrafficViews extends React.PureComponent {
  constructor(props) {
    super(props)
    this.tableColumns = getTableColumns([
      {
        key: 'createdAt',
        label: 'View Date',
        isSortable: true,
        normalizer: formatDay,
      },
      {
        key: 'total',
        label: 'No. of Visits',
        isSortable: true,
      },
      {
        key: 'directVisits',
        label: 'No. of Direct Visits',
        isSortable: true,
      },
      {
        key: 'referralVisits',
        label: 'No. of Referral Visits',
        isSortable: true,
      },
      //TODO: Ritesh will clarify RAW formula
      /*{
        key: 'rawVisits',
        label: 'No. of Raw Visits',
        isSortable: true
      }, */
      {
        key: 'uniqueVisits',
        label: 'No. of Unique Visits',
        isSortable: true,
      },
    ])

    this.detailsTableColumns = getTableColumns([
      {
        key: 'createdAt',
        label: 'View Hour',
        className: 'detail-cell',
        isSortable: true,
        normalizer: formatDateTime,
      },
      {
        key: 'total',
        label: 'No. of Visits',
        className: 'detail-cell',
        isSortable: true,
      },
      {
        key: 'directVisits',
        label: 'No. of Direct Visits',
        className: 'detail-cell',
        isSortable: true,
      },
      {
        key: 'referralVisits',
        label: 'No. of Referral Visits',
        className: 'detail-cell',
        isSortable: true,
      },
      //TODO: Ritesh will clarify RAW formula
      /* {
        key: 'rawVisits',
        label: 'No. of Raw Visits',
        className: 'detail-cell',
        isSortable: true
      }, */
      {
        key: 'uniqueVisits',
        label: 'No. of Unique Visits',
        className: 'detail-cell',
        isSortable: true,
      },
    ])

    this.footbarColumns = [
      { key: 'total', sourceKey: 'total' },
      { key: 'directVisits', sourceKey: 'directVisits' },
      { key: 'referralVisits', sourceKey: 'referralVisits' },
      { key: 'rawVisits', sourceKey: 'rawVisits' },
      { key: 'uniqueVisits', sourceKey: 'uniqueVisits' },
    ]

    this.state = {
      sortBy: { column: 'createdAt', asc: false },
      sortBySubTable: { column: 'createdAt', asc: true },
      filterUpdateVersion: 0,
    }
  }

  isEmptyChecker = data => {
    const { startDate, endDate } = data
    return !(startDate && endDate)
  }

  onSaveFilter = () => {
    this.setState(s => ({ filterUpdateVersion: s.filterUpdateVersion + 1 }))
  }

  onSelectFilter = template => {
    const { onDatesApply } = this.props
    let { value } = template

    try {
      value = JSON.parse(value)
      const { startDate, endDate } = value
      onDatesApply(moment(startDate), moment(endDate))
    } catch (e) {
      showAxiosError(e)
    }
  }

  getPercentage = (total, value) => Math.round((value * 100) / total)

  render() {
    const {
      event,
      trafficDataObj,
      trafficTableData,
      isLoadingTrafficData,
      rawVisitsData,
      directVisitsData,
      referralVisitsData,
      uniqueVisitsData,
      detailsRowData,
      getDetailRowData,
      startDate,
      endDate,
      onDatesApply,
      params,
      setTrafficDataParams,
    } = this.props
    const trafficData = trafficDataObj[`event_${params[0].group_by[0]}`] ?? []

    const { sortBy, filterUpdateVersion } = this.state
    const showSaveTemplateBtn = startDate && endDate

    const countState = trafficData.length

    const chart1Total = uniqueVisitsData + rawVisitsData
    const chart2Total = directVisitsData + referralVisitsData
    const referralVisitsPercent = this.getPercentage(chart2Total, referralVisitsData)
    const directVisitsPercent = this.getPercentage(chart2Total, directVisitsData)
    // TODO: Ritesh will clarify RAW formula
    //const rawVisitsPercent = this.getPercentage(chart1Total, rawVisits)
    const uniqueVisitsPercent = this.getPercentage(chart1Total, uniqueVisitsData)

    return (
      <div ref="cardContainer" className="performance-sales traffic-views">
        <CardHeader imageUrl="/resources/images/event/performance/ticket-sales-ico.svg" bodyText="Views" />
        <div className="table-background">
          {isLoadingTrafficData ? (
            <LoadingBar title={"Hold tight! We're getting your statistics..."} />
          ) : countState === 0 ? (
            <EmptyBar />
          ) : (
            <div>
              <TrafficViewChart
                traffic={trafficData}
                changeTime={time => setTrafficDataParams([{ ...params[0], group_by: [time] }])}
                time={params[0].group_by[0]}
              />
              {countState !== 0 ? (
                <div className="event-traffic-circles">
                  <div style={{ width: '600px' }} className="event-traffic-circle">
                    <div className="col-xs-12 col-sm-4 blue-circle">
                      <ProgressCircle value={directVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{directVisitsData}</div>
                            <div className="circle-type">Direct Visits</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 pink-circle">
                      <ProgressCircle value={referralVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{referralVisitsData}</div>
                            <div className="circle-type">Referral Visits</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: '600px' }} className="event-traffic-circle">
                    {/* TODO Ritesh will clarify RAW formula
                    <div className="col-xs-12 col-sm-4 blue-circle">
                      <ProgressCircle value={rawVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{rawVisits}</div>
                            <div className="circle-type">Raw Visits</div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-xs-12 col-sm-4 pink-circle">
                      <ProgressCircle value={uniqueVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{uniqueVisitsData}</div>
                            <div className="circle-type">Unique Visits</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {countState > 0 && (
                <div className="row performance-sales-daterange">
                  <div className="col-sm-8 col-xs-12">
                    <div
                      style={{ display: 'inline-block', marginTop: 10, marginBottom: 10, marginRight: 10 }}
                    >
                      <DateRangePicker
                        onApply={onDatesApply}
                        onClear={onDatesApply}
                        value={{ startDate, endDate }}
                      />
                    </div>
                    {showSaveTemplateBtn ? (
                      <div style={{ margin: '10px 0px', display: 'inline-block' }}>
                        <SaveTemplate
                          data={{
                            startDate,
                            endDate,
                          }}
                          isEmptyChecker={this.isEmptyChecker}
                          storagePath={`event-${event.id}-performance-ticket-sales-filter`}
                          onSaveFilter={this.onSaveFilter}
                        />
                      </div>
                    ) : null}
                  </div>
                  <div
                    className="col-sm-4 col-xs-12"
                    style={{ margin: '10px 0', textAlign: isMobileDevice() ? 'start' : 'end' }}
                  >
                    <SelectFilterTemplate
                      storagePath={`event-${event.id}-performance-ticket-sales-filter`}
                      onSelectFilter={this.onSelectFilter}
                      updateVersion={filterUpdateVersion}
                    />
                  </div>
                </div>
              )}
              <SortableTable
                isAsyncDetails
                data={trafficTableData}
                tableColumns={this.tableColumns}
                enableSort={true}
                enableCopyTable={true}
                disableMobileView={true}
                sortBy={sortBy}
                detailsRows={detailsRowData.map(({ data, ...item }) => ({
                  ...item,
                  component: (
                    <SortableTable
                      data={data}
                      tableColumns={this.detailsTableColumns}
                      enableSort={true}
                      enableCopyTable={true}
                      disableMobileView={true}
                      className="child-table"
                      sortBy={this.state.sortBySubTable}
                    />
                  ),
                }))}
                getDetailRowData={getDetailRowData}
                footbar={{
                  label: 'Total',
                  columns: this.footbarColumns,
                }}
                scrollToRowEnabled={true}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}
